// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + "fb6a40bc713a0136e678" + ".js";
};